import $ from 'jquery'

if (typeof window === 'object') {
  window.$ = window.jQuery = $
}

export default $
